import { NgModule } from '@angular/core';

import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatDialogModule } from '@angular/material/dialog';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTabsModule } from '@angular/material/tabs';

import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';

import { MatAutocompleteModule } from '@angular/material/autocomplete';

import { MatTooltipModule } from '@angular/material/tooltip';
import { MatChipsModule } from '@angular/material/chips';

// import { MatCardModule } from '@angular/material/card';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonToggleModule } from '@angular/material/button-toggle';

@NgModule({
  declarations: [],
  imports: [
    MatBadgeModule,
    MatButtonModule,
    MatSnackBarModule,
    MatDialogModule,
    MatPaginatorModule,
    MatSelectModule,
    MatSlideToggleModule,
    MatTabsModule,

    MatDatepickerModule,
    MatNativeDateModule,

    MatAutocompleteModule,

    MatTooltipModule,

    MatTabsModule,

    // MatCardModule,
    MatMenuModule,
    MatButtonToggleModule,
  ],
  exports: [
    MatBadgeModule,
    MatButtonModule,
    MatSnackBarModule,
    MatDialogModule,
    MatPaginatorModule,
    MatSelectModule,
    MatSlideToggleModule,
    MatTabsModule,

    MatDatepickerModule,
    MatNativeDateModule,

    MatAutocompleteModule,

    MatTooltipModule,

    MatTabsModule,

    MatChipsModule,

    // MatCardModule,
    MatMenuModule,
    MatButtonToggleModule,
  ],
})
export class MaterialModule {}
